import { isEmpty } from "./isEmpty"

type ConvertToLocaleParams = {
  amount: number
  currency_code: string
  minimumFractionDigits?: number
  maximumFractionDigits?: number
  locale?: string
}

/**
 * Kvatronix price formatter — outputs `1234.56 UAH` (amount first, ISO code after).
 *
 * Medusa's default `Intl.NumberFormat({ style: "currency" })` produces
 * `UAH 1,234.56` which doesn't match our brand voice. We always render the
 * number with Latin digits + a non-breaking space + uppercased ISO code so it
 * looks identical across UA / RU / EN.
 */
export const convertToLocale = ({
  amount,
  currency_code,
  minimumFractionDigits = 2,
  maximumFractionDigits = 2,
}: ConvertToLocaleParams) => {
  if (!currency_code || isEmpty(currency_code)) {
    return amount.toString()
  }

  const formatted = new Intl.NumberFormat("en-US", {
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(amount)

  return `${formatted} ${currency_code.toUpperCase()}`
}
